import { useLocation, useNavigate } from '@tanstack/react-router';

import { IconButton } from '../../../cdl/IconButton/IconButton';
import { translate } from '../../../common/helpers/translate.helper';
import { IconCopy } from '../../../common/icons/cdl/Copy';

const getDuplicateTooltipForOrderState = (order) => {
    if (order.isDraft()) {
        return translate('actionListLabel.copyDraftTo');
    }

    if (order.isClosed()) {
        return translate('actionListLabel.copyTo');
    }

    return translate('actionListLabel.copyEnquiryTo');
};

export const DuplicateOrderButton = ({ order }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const onDuplicateOrderClick = (e) => {
        e.stopPropagation();

        navigate({ to: '/orders/new', state: { order, originLocation: location } });
    };

    return (
        <IconButton
            Icon={IconCopy}
            tooltipLabel={getDuplicateTooltipForOrderState(order)}
            onClick={onDuplicateOrderClick}
        />
    );
};
